/**
 * Resolves the host the app is running on, used to drive tenant-aware
 * server-side flows (e.g. selecting the correct Cognito User Pool by domain).
 *
 * Resolution order:
 * 1. `REACT_APP_DOMAIN` environment variable (parsed as URL when possible).
 * 2. `window.location.hostname` when running in a browser context.
 * 3. `undefined` when neither source is available (e.g. SSR/tests without DOM).
 */
export const getAppDomainHost = (): string | undefined => {
  const envDomain = process.env.REACT_APP_DOMAIN;
  if (envDomain) {
    try {
      return new URL(envDomain).hostname;
    } catch {
      return envDomain;
    }
  }
  if (typeof window !== 'undefined' && window.location?.hostname) {
    return window.location.hostname;
  }
  return undefined;
};
